export const CHI_EVENT_CATEGORIES = [
  "AI / Tech",
  "Leadership",
  "Talent",
  "HR",
  "Motivational",
  "Community",
] as const;

export type CHIEventCategory = (typeof CHI_EVENT_CATEGORIES)[number];